import React from "react";

const ArrowDropDownIcon = ({
  width = "16",
  height = "17",
  fill = "black",
  className = "",
  ...props
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      {...props}
    >
      <mask
        id="mask0_771_20710"
        style={{ maskType: "alpha" }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="16"
        height="16"
      >
        <rect
          y="16"
          width="16"
          height="16"
          transform="rotate(-90 0 16)"
          fill="#D9D9D9"
        />
      </mask>
      <g mask="url(#mask0_771_20710)">
        <path
          d="M8.00088 9.97706L12.8227 5.15522C12.944 5.03389 13.0944 4.97211 13.2739 4.96989C13.4534 4.96778 13.6039 5.02739 13.7252 5.14872C13.8465 5.27017 13.9072 5.42061 13.9072 5.60006C13.9072 5.7795 13.8465 5.92994 13.7252 6.05139L8.75471 11.0154C8.64527 11.1248 8.52688 11.2031 8.39954 11.2501C8.27221 11.2971 8.13932 11.3206 8.00088 11.3206C7.86243 11.3206 7.72954 11.2971 7.60221 11.2501C7.47488 11.2031 7.35649 11.1248 7.24704 11.0154L2.28288 6.05139C2.16154 5.92995 2.09982 5.78056 2.09771 5.60322C2.0956 5.42589 2.15521 5.27656 2.27654 5.15522C2.39788 5.03389 2.54832 4.97322 2.72788 4.97322C2.90732 4.97322 3.05771 5.03389 3.17904 5.15522L8.00088 9.97706Z"
          fill={fill}
        />
      </g>
    </svg>
  );
};

export default ArrowDropDownIcon;
